<template>
    <div class="cervd-404">
        <div class="cervd-404__space">
            <div class="cervd-404__space__body">
                <h1 class="cervd-404__space__body__label">404</h1>
                <p class="cervd-404__space__body__text">
                    Ser ut som om du är <br />
                    VILSE I RYMDEN
                </p>
                <button class="btn btn--cta" @click="goBack">Ta mig till planeten Falagrett</button>
            </div>

            <div class="cervd-404__space__objects">
                <img class="cervd-404__space__objects__rocket" src="/images/rocket.svg" />

                <div class="cervd-404__space__objects__earth-moon">
                    <img class="cervd-404__space__objects__earth-moon__earth" src="/images/earth.svg" width="100px" />
                    <img class="cervd-404__space__objects__earth-moon__moon" src="/images/moon.svg" width="80px" />
                </div>

                <div class="cervd-404__space__objects__box-astronaut">
                    <img
                        class="cervd-404__space__objects__box-astronaut__img"
                        src="/images/astronaut.svg"
                        width="140px"
                    />
                </div>
            </div>

            <div class="cervd-404__stars__glowing">
                <div class="star"></div>
                <div class="star"></div>
                <div class="star"></div>
                <div class="star"></div>
                <div class="star"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useRouter } from 'vue-router';

    export default {
        setup() {
            const router = useRouter();
            const goBack = () => router.push('/');

            return { goBack };
        },
    };
</script>
